import { createContext, useContext, useState, useCallback } from 'react';

const CompareContext = createContext(null);

export function CompareProvider({ children }) {
  const [compareList, setCompareList] = useState([]);
  // Each item: { itemCode, description, productLine, subcategory, thumbnailUrl }

  const addToCompare = useCallback((product) => {
    setCompareList(prev => {
      if (prev.length >= 3) return prev;
      if (prev.some(p => p.itemCode === product.itemCode)) return prev;
      return [...prev, {
        itemCode: product.itemCode,
        description: product.description,
        productLine: product.productLine,
        subcategory: product.subcategory,
        thumbnailUrl: product.images?.[0]?.src || product.imageUrl || null,
      }];
    });
  }, []);

  const removeFromCompare = useCallback((itemCode) => {
    setCompareList(prev => prev.filter(p => p.itemCode !== itemCode));
  }, []);

  const clearCompare = useCallback(() => setCompareList([]), []);

  const isInCompare = useCallback((itemCode) => {
    return compareList.some(p => p.itemCode === itemCode);
  }, [compareList]);

  return (
    <CompareContext.Provider value={{ compareList, addToCompare, removeFromCompare, clearCompare, isInCompare }}>
      {children}
    </CompareContext.Provider>
  );
}

export function useCompare() {
  const context = useContext(CompareContext);
  if (!context) throw new Error('useCompare must be used within CompareProvider');
  return context;
}

export default CompareContext;
